const MAX_SEGMENTS = 3;

export const isPlpNoFollow = (slug: string): boolean => {
  const slugSegments = slug.split('_').length;
  return slugSegments > MAX_SEGMENTS;
};
